import React from 'react';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { ButtonBase, DialogActions, Typography } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/CloseOutlined';
import SuccessIcon from '@material-ui/icons/CheckCircleTwoTone';
import s from './Success.module.scss';
import Button from '@material-ui/core/Button';

export function SuccessPage(props) {
    return (
        <>
            <DialogTitle>
                <div className={'row'}>
                    <div className="col-1 text-right">
                        <ButtonBase onClick={props.Close}>
                            <CloseIcon />
                        </ButtonBase>
                    </div>
                    <div className="col-10 p-1 text-center">
                        <SuccessIcon
                            className={`text-success font-weight-bold ${s.fadeIn}`}
                            fontSize={'large'}
                        />
                    </div>
                </div>
                <div className={'row'}>
                    <div className="col-12 text-center">
                    <Typography variant='h5' align='center' >
                        پرداخت موفق
                    </Typography>
                    </div>
                </div>
            </DialogTitle>
            <DialogContent className='p-3 text-center'>
                <Typography variant='body1' align='center' className='p-2' >
                    مبلغ :‌ {props.price}
                </Typography>
                <Typography variant='body1' align='center' className='p-2 font-weight-bold' >
                    کد رهگیری :‌ {props.track}
                </Typography>

            </DialogContent>
            <DialogActions className='text-center pt-3 pb-3'>
                <Button variant='contained' color='primary' className='m-auto' onClick={props.Close} >
                    بازگشت به سایت
                </Button>
            </DialogActions>
        </>
    )
}

export default SuccessPage;